<template>
  <div class="footer">
    <div class="text-center p-3">Copyright {{year}} © ລາວສະຕ່າ</div>
  </div>
</template>
<script>
import moment from '@/moment'

export default {
  data() {
    return {
      year: moment().format("YYYY")
    }
  }
}
</script>
<style lang="scss">
.footer {
  background-color: #870000;
  color: #FFF;
}
</style>
